/*
    Polyfills and haks for IE.
*/
/*eslint-disable */
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

/*
if (!window.Intl) {
  require.ensure(['intl'], (require) => {
    window.Intl = require('intl')
  }, "IntlBundle");
}
*/

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
           isFinite(value) &&
           Math.floor(value) === value;
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/utils/ie.js